import addIcon from '@brands/Dashboard/Sidenav/Icons/addDependentSVG.svg';
import React from 'react';

import { ICase } from '../../../../services/cases/types/ICase';
import { addAdditionalInformationAvailability } from '../../../../Utils/getFriendlyName';
import styles from '../appointments.module.scss';

interface Props {
  appointment: ICase;
  setAdditionalInformationModal: React.Dispatch<React.SetStateAction<boolean>>;
  setCase: React.Dispatch<React.SetStateAction<ICase | undefined>>;
}

const AddAdditionalInformationButton = ({
  appointment,
  setAdditionalInformationModal,
  setCase,
}: Props): JSX.Element => {
  return addAdditionalInformationAvailability(appointment) ? (
    <button
      type="button"
      className={`fs-unmask ${styles.cancelBtn}`}
      onClick={() => {
        setCase(appointment);
        setAdditionalInformationModal(true);
      }}
    >
      <img src={addIcon} />
      Add additional information
    </button>
  ) : (
    <div />
  );
};

export default AddAdditionalInformationButton;
